module.exports = __webpack_public_path__ + "static/img/oval9.b37e28ac.png";